import { render, staticRenderFns } from "./AufzugheldenApi.vue?vue&type=template&id=41b3f194&lang=pug&"
import script from "./AufzugheldenApi.vue?vue&type=script&lang=ts&"
export * from "./AufzugheldenApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports